export default "__VITE_ASSET__BcJBOFLU__"